<nav #header *ngIf="renderMenu" class="fixed-top headerStyle"
  [ngClass]="{ navbar2: this.companyParamsService.getFadeMenu() }"
  style="background-color: black; filter: drop-shadow(1px 1px 1px #6666664d)">
  <div class="desktop-container">
    <div>
      <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
        role="tooltip" id="tooltip164687" x-placement="right" style="
          position: absolute;
          will-change: transform;
          top: 0px;
          left: 0px;
          transform: translate3d(266px, 24px, 0px);
        ">
        <div class="arrow" style="top: 8px"></div>
        <div class="tooltip-inner">Your Logo Here</div>
      </div>
      <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
        data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
      </a>
      <a *ngIf="this.companyParamsService.getWebSite()" href="{{ this.companyParamsService.getWebSite() }}"
        target="_blank">
        <input type="hidden" value="{{ this.companyParamsService.getCompanyParams().logoFade }}" id="logoFade" />
        <input type="hidden" value="{{ this.companyParamsService.getCompanyParams().fadeMenu }}" id="fadeMenu" />
        <span class="custom-logo"></span>
      </a>
    </div>
    <div>
      <div #header1 class="container green containerMenu" style="justify-content: space-between">
        <div style="display: contents">
          <div class="containerMenu navbar-collapse collapse" style="
              flex-basis: 0%;
              align-items: end;
              justify-content: end;
              flex-direction: column;
              gap: 10px;
              margin-top: 9px;
            ">
            <div class="social-links">
              <a href="https://www.facebook.com/handmadetravel.ch" target="_blank">
                <img src="../../../../../../../../assets/images/logos-header/fb.png" alt="Facebook" /></a>
              <a href="https://www.pinterest.com/handmadetravel1/" target="_blank">
                <img src="../../../../../../../../assets/images/logos-header/pinterest.png" alt="Pinterest" /></a>
              <a href="https://www.handmade-travel.ch/" target="_blank">
                <img src="../../../../../../../../assets/images/logos-header/yt.png" alt="YouTube" /></a>
              <a href="mailto:info&#64;handmade-travel.ch" class="email-link">E-Mail senden</a>
            </div>
            <div>
              <ul class="navbar-nav menuContainer">
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/" target="_blank">Home</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/wir-ueber-uns/" target="_blank">Handmade Travel</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/" target="_blank">Reiseziele</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/blog/reiseberichte/" target="_blank">Reiseberichte</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/waehrungsrechner/" target="_blank">Währungsrechner</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/kontakt/" target="_blank">Kontakt</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/blog/news-aus-ecuador/" target="_blank">Reiseblog</a>
                </li>
                <li class="nav-item menuItem item">
                  <a href="https://www.handmade-travel.ch/newsletter/" target="_blank">Newsletter</a>
                </li>
                <li class="item-wish">
                  <div *ngIf="companyParamsService.getFiltersInterest()" class="tooltip-container">
                    <app-heart-header></app-heart-header>
                  </div>
                </li>
                <li class="nav-item menuItem">
                  <div class="menu-btn-responsive">
                    <a class="menu-hamburger" (click)="renderMenu()" href="javascript:void()"
                      style="padding-left: 10px">
                      <i class="fa fa-bars fa-2x"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
  <div class="responsiveHeader">
    <div class="navbar-responsive">
      <img src="../assets/images/logos-header/logo-gross.png" />
      <div class="menu-btn-responsive">
        <a class="" (click)="renderMenu()" href="javascript:void()" style="padding-left: 10px">
          <i class="fa fa-bars fa-2x"></i>
        </a>
      </div>
    </div>
  </div>
  <div style="margin: 10px">
    <ul style="width: inherit; display: none" class="menuContainer" [ngClass]="showMenu ? 'showMenu' : ''">
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/" target="_blank">Home</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/wir-ueber-uns/" target="_blank">Handmade Travel</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/" target="_blank">Reiseziele</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/blog/reiseberichte/" target="_blank">Reiseberichte</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/waehrungsrechner/" target="_blank">Währungsrechner</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/kontakt/" target="_blank">Kontakt</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/blog/news-aus-ecuador/" target="_blank">Reiseblog</a>
      </li>
      <li class="nav-item menuItem">
        <a href="https://www.handmade-travel.ch/newsletter/" target="_blank">Newsletter</a>
      </li>
      <li class="nav-item menuItem cta-button">
        <a href="https://www.handmade-travel.ch/blog/news-aus-ecuador/" style="color: white !important"
          target="_blank">Jetzt anfragen</a>
      </li>
    </ul>
  </div>
</nav>
<div class="elfsight-app-1acc3ea9-11f5-4b09-9d4d-4644312a8003" data-elfsight-app-lazy></div>